import React from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMyself } from "@api/v1/hooks/useMyself";
import { useAppLayout } from "@providers/AppLayoutProvider";

export interface ArivaPremiumButtonProps {
  onClick?: () => void;
}

/**
 * "Test Premium" button for the Ariva sidebar. On boersennews this lives in
 * the sidebar header; for Ariva the header top section is hidden, so the
 * button is rendered full-width at the bottom of the sidebar instead.
 * Shown for free users only, and hidden while the sidebar is collapsed.
 */
export const ArivaPremiumButton = ({ onClick }: ArivaPremiumButtonProps) => {
  const { t } = useTranslation();
  const { data: myself } = useMyself();
  const { sidebarCollapsed: collapsed } = useAppLayout();

  if (!myself?.isUserFree || collapsed) return null;

  return (
    <Box mb={2}>
      <Button onClick={onClick} variant="primary" color="upgrade" fullWidth>
        {t("sidebar.header.testPremium")}
      </Button>
    </Box>
  );
};
